import { TouchableRipple } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniTouchableRipple = withUnistyles(TouchableRipple)

export default UniTouchableRipple
